import axioPath from '../../../api/axioPath';
import { UPDATE_DATA } from 'redux/actions/action_types'

import { showAppLoader, hideAppLoader } from '../app';

export const upgradeGuestSignup = (data, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .post('/user/upgrade_user', data, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      return ex;
    });
};

export const getGuestUserBasicInfo = (userId, token) => (dispatch) => {
  dispatch(showAppLoader())
  return axioPath
    .get('/user/guest_user_details/' + userId, {
      headers: {
        Authorization: `${token}`,
      },
    })
    .then((response) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response;
    })
    .catch((ex) => {
      setTimeout(
        () => {
          dispatch(hideAppLoader());
        },
        3000
      );
      return ex;
    });
};